import React, { useMemo, useState } from 'react';
import * as Styles from 'components/wh/instance/style';
import CustomButton from 'components/common/custom-button';
import { Grid, Pagination } from '@mui/material';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { get } from 'lodash';
import ConditionalFragment from 'components/conditional-fragment';
import { CustomHook } from 'utils/custom-hook';
import classes from 'components/manage-vm/manage-vm.module.css';
import { P } from 'components/reusable-css';
import { Heading } from 'assets/css/common-styles';
import { navLinks } from 'utils/nav-links-util';
import ManageWhCard from 'components/wh/instance/ManageWhCard';
import ManageWhMobile from 'components/wh/instance/ManageWhMobile';
import { Highlight } from 'components/common';
import { SortCard } from 'components/wh/instance/SortCard';
import { ManagePagination } from 'components/wh/instance/Pagination';
import { backPageValidation, nextPageValidation } from 'components/wh/instance/util';

const WhInstance = ({ whData, setQueries, queries, managerWhRefetch, managerWhIsFetching }) => {
  const { per_page, isMobile } = CustomHook();
  const { t } = useTranslation();
  const [deletedIds, setDeletedIds] = useState([]);

  const handlePagination = (value) => {
    setQueries({
      ...queries,
      page_number: 1,
      per_page: value.target.value,
    });
  };
  const handleBottomPagination = (event, value) => {
    setQueries({
      ...queries,
      page_number: value,
    });
  };

  const handleNextPage = () => {
    if (nextPageValidation(whData, queries)) {
      setQueries({
        ...queries,
        page_number: Number(queries.page_number) + 1,
      });
    }
  };

  const handleBackPage = () => {
    if (backPageValidation(queries)) {
      setQueries({
        ...queries,
        page_number: Number(queries.page_number) - 1,
      });
    }
  };
  const detailOfServers = useMemo(() => get(whData, 'data', []), [whData]);
  const isPagination = useMemo(() => Math.ceil(whData?.meta?.total / +per_page) > 1, [whData]);

  return (
    <React.Fragment>
      <ConditionalFragment condition={detailOfServers.length}>
        <Styles.ManageVMSC>
          <Styles.ManageVMs>
            <Styles.BuildVM>
              <div>
                <Heading>
                  <Trans i18nKey={'wh/instance.string1'} components={{ highlight: <Highlight /> }} />
                </Heading>
                <Styles.SearchVMs>
                  <Styles.Searching>
                    <SortCard setQueries={setQueries} queries={queries} />
                    <ConditionalFragment condition={!isMobile}>
                      <ManagePagination
                        handleBackPage={handleBackPage}
                        handleNextPage={handleNextPage}
                        handlePagination={handlePagination}
                        pagination={isPagination}
                        whData={whData}
                        queries={queries}
                      />
                    </ConditionalFragment>
                  </Styles.Searching>
                </Styles.SearchVMs>
              </div>

              <ConditionalFragment condition={!isMobile}>
                <Link to={navLinks.deploy_a_web_hosting_container.link}>
                  <CustomButton title={t('wh/instance.string2')} />
                </Link>
              </ConditionalFragment>
            </Styles.BuildVM>
          </Styles.ManageVMs>
          <ConditionalFragment condition={isMobile}>
            <Link className={classes.mobile_manage_btn} to={navLinks.deploy_a_web_hosting_container.link}>
              <CustomButton
                title={t('vs/instance.string2')}
                buttonStyles={{
                  margin: '1rem 0',
                }}
              />
            </Link>
          </ConditionalFragment>

          <ConditionalFragment condition={isMobile}>
            <Styles.SearchVMs>
              <Styles.Searching className={classes.manage_mobile_pagination}>
                <ManagePagination
                  handleBackPage={handleBackPage}
                  handleNextPage={handleNextPage}
                  handlePagination={handlePagination}
                  pagination={isPagination}
                  whData={whData}
                  queries={queries}
                />
              </Styles.Searching>
            </Styles.SearchVMs>
          </ConditionalFragment>

          <Grid item xs={12}>
            <ConditionalFragment condition={!isMobile}>
              <Styles.Cards>
                {detailOfServers?.map((data) => (
                  <ManageWhCard
                    key={data.id}
                    data={data}
                    managerWhRefetch={managerWhRefetch}
                    managerWhIsFetching={managerWhIsFetching}
                    setDeletedIds={setDeletedIds}
                    deletedIds={deletedIds}
                  />
                ))}
              </Styles.Cards>
            </ConditionalFragment>
            <ConditionalFragment condition={isMobile}>
              {detailOfServers?.map((data) => (
                <ManageWhMobile
                  key={data.id}
                  data={data}
                  managerWhRefetch={managerWhRefetch}
                  managerWhIsFetching={managerWhIsFetching}
                  setDeletedIds={setDeletedIds}
                  deletedIds={deletedIds}
                />
              ))}
            </ConditionalFragment>
          </Grid>

          <ConditionalFragment condition={isPagination}>
            <div className={classes.manage_bottom_mobile_pagination}>
              <Pagination
                variant="outlined"
                siblingCount={10}
                color="secondary"
                count={Number(whData?.meta?.how_many_pages)}
                page={Number(queries?.page_number)}
                onChange={handleBottomPagination}
              />
            </div>
          </ConditionalFragment>
        </Styles.ManageVMSC>
      </ConditionalFragment>
      <ConditionalFragment condition={!detailOfServers.length}>
        <Styles.NotFound>
          <div className={classes.noserver_container}>
            <div className={classes.noserver_inner_container}>
              <Heading>
                <Trans i18nKey={'wh/instance.string1'} components={{ highlight: <Highlight /> }} />
              </Heading>
              <Link to={navLinks.wh_instance.link}>
                <CustomButton title={t('wh/instance.string2')} />
              </Link>
            </div>
            <P className={classes.no_server}>{t('vs/instance.string51')}</P>
          </div>
        </Styles.NotFound>
      </ConditionalFragment>
    </React.Fragment>
  );
};

export default React.memo(WhInstance);
